<template>
  <ModalLinkButton :title="$t('Important Information')" :content="importantInfo"
                   class="ta-auction-important-information-link"/>
</template>

<script>
import auctionViewMixin from "@/mixins/auctionViewMixin";
import ModalLinkButton from "@/components/ModalLinkButton.vue";

export default {
  name: "AuctionImportantInformationLink",
  components: {ModalLinkButton},
  mixins: [auctionViewMixin],
}
</script>

<style lang="scss" scoped>
</style>
